module.exports = __webpack_public_path__ + "img/reimu hakurei lunar war shaman_sc1.1cde155a.png";